import polyfill from '../utils/polyfill';

import ajaxLoadMoreController from './ajax-load-more-controller';
import loadMoreController from './load-more-controller';

const polyfillUrl = 'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=fetch,Promise';

/**
 * Initialises the component when passed an element
 *
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  if (!rootElement) {
    return false;
  }

  const ajaxConfig = rootElement.getAttribute('data-ajax-config');

  const config = {
    itemsToShow: parseInt(rootElement.getAttribute('data-items-to-show'), 10),
    itemsToIncrement: parseInt(rootElement.getAttribute('data-items-to-increment'), 10),
    loadMoreButtonText: rootElement.getAttribute('data-button-label'),
    loadingText: rootElement.hasAttribute('data-loading-label') ? rootElement.getAttribute('data-loading-label') : '',
    noMoreItemsText: rootElement.hasAttribute('data-fallback-message') ? rootElement.getAttribute('data-fallback-message') : '',
    ajax: ajaxConfig ? JSON.parse(ajaxConfig) : null,
    href: rootElement.getAttribute('data-href')
  };

  if (ajaxConfig) {
    return polyfill('fetch' in window, polyfillUrl, () => {
      ajaxLoadMoreController(rootElement, config);
    });
  }

  return loadMoreController(rootElement, config);
}
